function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { company_queryPage, getExcelPath, download, company_import, saveCompany, deleteCompany } from "@/api/baseDataManage";
import { getCompanyList, getUpperCompany as _getUpperCompany, getChilComList } from "@/api/baseDate";
export default {
  name: "maintenancData",
  data: function data() {
    return {
      upperCompanys: [],
      //上级机构
      fileList: [],
      companys: [],
      //分支机构
      company: "",
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        insuranceCompanyCode: "",
        companyName: "",
        pageNo: 1,
        pageSize: 10,
        companyCode: "",
        upperComName: '',
        upperComCode: '',
        validStatus: '',
        validStatusName: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      // editData: {},
      markForm: {
        tbcCompanyId: "",
        type: "",
        companyCode: "",
        companyName: "",
        companyLevelCode: "",
        companyLevel: "",
        upperComCode: "",
        upperComName: "",
        upperCompanyView: "",
        //上级机构显示
        insuranceCompanyCode: JSON.parse(sessionStorage.getItem("newinsurancecompanyCode")),
        insuranceCompanyName: JSON.parse(sessionStorage.getItem("newinsurancecompanyName"))
      },
      markForm_new: {
        tbcCompanyId: "",
        type: "",
        companyCode: "",
        companyName: "",
        companyLevelCode: "",
        companyLevel: "",
        upperComCode: "",
        upperComName: "",
        upperCompanyView: "",
        //上级机构显示
        insuranceCompanyCode: JSON.parse(sessionStorage.getItem("newinsurancecompanyCode")),
        insuranceCompanyName: JSON.parse(sessionStorage.getItem("newinsurancecompanyName"))
      },
      isShow: false,
      institutionsrule: {
        companyCode: [{
          required: true,
          message: "请输入机构代码",
          trigger: "blur"
        }],
        companyName: [{
          required: true,
          message: "请输入机构名称",
          trigger: "blur"
        }],
        companyLevelCode: [{
          required: true,
          message: "请输入机构层级",
          trigger: "blur"
        }],
        upperCompanyView: [{
          required: true,
          message: "请选择上级机构",
          trigger: "change"
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 获取保险公司名称
    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem("newinsurancecompanyCode"));

      _this.getData();
    }); // 获取保险公司分支机构

    getChilComList({
      insuranceCompanyCode: this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode || ""
    }).then(function (res) {
      _this.companys = res;
    });
  },
  methods: {
    // 上级机构下拉内容显示/隐藏事件
    clickUppCompany: function clickUppCompany(type) {
      console.log(type, 'type');

      if (type == 'new') {
        this.getUpperCompany(this.markForm_new.companyLevelCode);
      } else {
        this.getUpperCompany(this.markForm.companyLevelCode);
      }
    },
    // 是否有效下拉框change事件
    changeStatus: function changeStatus(e) {
      console.log(e);
      this.form.validStatus = e.toString();
    },
    // 机构层级blur事件
    blurCompanyLevel: function blurCompanyLevel(e) {
      console.log('eeeeee', e.target.value, _typeof(e.target.value));

      if (!/(^[1-9]\d*$)/.test(Number(e.target.value))) {
        this.$message({
          type: 'warning',
          message: '请输入正整数'
        });
        e.target.value = '';
      }

      if (Number(e.target.value) > 1) {
        this.isShow = true;
      } else {
        this.isShow = false;
        this.markForm.upperComCode = '';
        this.markForm.upperComName = '';
      }

      this.markForm.upperCompanyView = '';
      this.markForm_new.upperCompanyView = ''; // this.getUpperCompany(e)
    },
    // // 编辑机构层级change事件
    // changeCompanyLevelEdit(e) {
    // 	console.log(parseInt(e));
    // 	// this.getUpperCompany(e)
    // 	this.markForm.companyLevelCode = e
    // 	this.markForm.upperCompanyView = ''
    // 	// this.upperCompanyView = "";
    // },
    // 获取上级机构
    getUpperCompany: function getUpperCompany(data) {
      var _this2 = this;

      data = data || 0;

      _getUpperCompany({
        companyLevel: data
      }).then(function (res) {
        console.log(res); // let a = [];
        // res.forEach((val) => {
        // 	if (val.upperComCode != null) {
        // 		a.push(val);
        // 	}
        // });

        _this2.upperCompanys = Object.assign([], res);
        console.log(_this2.upperCompanys);
      });
    },
    //上级机构选择变化
    changeUppers: function changeUppers(e) {
      console.log(e);
      console.log(e.split("-"));
      this.markForm_new.upperComCode = e.split("-")[0];
      this.markForm_new.upperComName = e.split("-")[1]; // console.log(this.markForm)

      this.markForm.upperComCode = e.split("-")[0];
      this.markForm.upperComName = e.split("-")[1]; // console.log(this.markForm)
    },
    //   查询
    submitForm: function submitForm(formName) {
      this.form.pageNo = 1;
      this.getData();
    },
    // 获取数据
    getData: function getData() {
      var _this3 = this;

      this.loading = true;
      company_queryPage(this.form).then(function (res) {
        console.log(res);
        _this3.loading = false;
        _this3.total = res.totalCount;
        _this3.tableData = Object.assign([], res.content);
      });
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.form.companyName = '';
      this.form.companyCode = '';
      this.form.upperComName = '';
      this.form.upperComCode = '';
      this.form.validStatus = '';
      this.form.validStatusName = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this4 = this;

      var data = type == "edit" ? this.markForm : this.markForm_new;
      console.log(data);

      if (type == "edit") {
        this.markForm.type = "1";
      } else {
        this.markForm_new.type = "0";
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.new_edit = _this4.newumarBtn = false;

          _this4.openFullScreen();

          saveCompany(data).then(function (res) {
            console.log(res);

            if (res.resultCode == "0000") {
              _this4.$message({
                message: "保存成功",
                type: "success"
              });

              for (var key in _this4.markForm_new) {
                _this4.markForm_new[key] = "";
              }

              _this4.markForm_new.insuranceCompanyCode = JSON.parse(sessionStorage.getItem("newinsurancecompanyCode"));
              _this4.markForm_new.insuranceCompanyName = JSON.parse(sessionStorage.getItem("newinsurancecompanyName"));

              _this4.getData();
            } else {
              _this4.$alert(res.resultMsg, '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this4.newumarBtn = type == 'new' ? true : false;
                  _this4.new_edit = type == 'edit' ? true : false;
                }
              });
            }

            _this4.screenLoading.close(); // this.markForm_new = {
            // 	tbcCompanyId: "",
            // 	type: "",
            // 	companyCode: "",
            // 	companyName: "",
            // 	companyLevelCode: "",
            // 	companyLevel: "",
            // 	upperComCode: "",
            // 	upperComName: "",
            // 	insuranceCompanyCode: JSON.parse(
            // 		sessionStorage.getItem("newinsurancecompanyCode")
            // 	),
            // 	insuranceCompanyName: JSON.parse(
            // 		sessionStorage.getItem("newinsurancecompanyName")
            // 	),
            // };


            _this4.upperCompanys = [];
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      console.log(data);
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      }

      this.markForm.upperCompanyView = data.upperComCode === null ? "无" : data.upperComCode + "-" + data.upperComName;
      console.log(this.markForm);
    },
    // // 删除
    // dele(data) {
    // 	console.log(data)
    // 	this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		type: 'warning'
    // 	}).then(() => {
    // 		deleteCompany({
    // 			companyCode: data.companyCode
    // 		}).then(res => {
    // 			console.log(res)
    // 			if (res.resultCode == '0000') {
    // 				this.$message({
    // 					type: 'success',
    // 					message: '删除成功!'
    // 				})
    // 				this.getData()
    // 			} else {
    // 				this.$message({
    // 					type: 'warning',
    // 					message: res.resultMsg
    // 				})
    // 			}
    // 		})
    // 	}).catch(() => {
    // 		this.$message({
    // 			type: 'info',
    // 			message: '已取消删除'
    // 		});
    // 	});
    // },
    // 禁用
    noRight: function noRight(data, status) {
      var _this5 = this;

      console.log(data);
      var str = "";
      if (status == "0") str = "禁用";else str = "启用";
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(str, "\u8BE5\u673A\u6784\u53CA\u5176\u4E0B\u5C5E\u673A\u6784, \u662F\u5426\u7EE7\u7EED?"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        deleteCompany({
          companyCode: data.companyCode,
          validstatus: status
        }).then(function (res) {
          if (res.resultCode == "0000") {
            _this5.$message({
              type: "success",
              message: res.resultMsg
            });

            _this5.getData();
          } else {
            _this5.$message({
              type: "warning",
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this5.$message({
          type: "info",
          message: "已取消操作"
        });
      });
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this6 = this;

      // this.upperCompanyView = "";
      if (type == "new") {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this6.$refs[formname].clearValidate();
      }); // this.upperCompanyView = "";
      // this.companyLevelView = "";

      this.upperCompanys = [];
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: "company"
      }).then(function (res) {
        if (res.rtnCode == "0000") {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "机构数据维护清单模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "机构数据维护清单模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this7 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf(".") + 1);

      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx或者.xls的文件");
        return;
      }

      var dataFile = new FormData();
      dataFile.append("file", file.file);
      this.openFullScreen2();
      company_import(dataFile).then(function (res) {
        _this7.screenLoading.close();

        if (res.resultCode == "0000") {
          _this7.$message({
            type: "success",
            message: "导入成功"
          });

          _this7.getData();
        } else {
          _this7.$message({
            type: "warning",
            message: res.resultMsg
          });
        }
      });
    }
  }
};